import ARK_EXT_1 from "./ARK_EXT_1";
export default {
  ARK_EXT_1,
};
